import { useState, useEffect, useCallback } from "react";
import axiosConfig from "../../../services/Axios";
import Select from "react-select";
import SelectTheme from "./SelectTheme";
import { useTranslation } from "react-i18next";
import SelectStyle from "./SelectStyle";

const SelectRoles = ({
  onChange,
  cancelToken = null,
  emptyOpt = false,
  className,
}) => {
  const [options, setOptions] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  const { t } = useTranslation();

  const fetchRoles = useCallback(async (token) => {
    return await axiosConfig
      .get(
        process.env.REACT_APP_API_URL +
          "/api/users/available_roles?pagination=false",
        {
          cancelToken: token,
        }
      )
      .then((response) => {
        let roles = emptyOpt ? [{ label: t("global.all"), value: "" }] : [];

        response.data["hydra:member"].map((role) => {
          roles.push({
            value: role,
            label: t("roles." + role.toLowerCase()),
          });
        });

        return roles;
      })
      .catch(function (thrown) {
        if (axiosConfig.isCancel(thrown)) {
          console.log("Roles Request canceled : ", thrown.message);
        }
      });
  }, []);

  useEffect(() => {
    fetchRoles(cancelToken).then((response) => {
      setOptions(response);
    });
  }, [cancelToken]);

  return (
    <>
      <Select
        isSearchable={true}
        options={options}
        value={selectedValue}
        onChange={(e) => {
          onChange(e.value !== "" ? e.value : null);
          setSelectedValue(e);
        }}
        className={`${className} w-full react-select-container`}
        styles={SelectStyle}
        theme={SelectTheme}
      />
    </>
  );
};

export default SelectRoles;
